import React, { useState, useEffect } from 'react'
//Helpers
import { ElementHTML } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import useQueryProperty from '@hooks/useQueryProperty'
import {
  getAge,
  getBathrooms,
  getEnvironment,
  getOrientation,
  getPrices,
  getRooms,
  getSurfaces,
  getType,
} from '@helpers/helper.properties'

const AboutProperty_3 = ({
  propertyID,
  global_data,
  titleElement,
  title,
  titleHexa,
  paragraphHexa,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  const [half, setHalf] = useState(false)

  useEffect(() => {
    var form = document.getElementById('form-detail-float')
    if (form) {
      setHalf(true)
    }
  }, [])

  return (
    <section
      className={
        'ficha-description c p-y-config dev ' +
        (isLoading ? 'skeleton' : '') +
        (half ? ' half-container-fluid-left' : '')
      }
    >
      <Container fluid>
        <Row>
          <Col lg={12}>
            <ElementHTML
              style={{ color: titleHexa || '#1f1f1f' }}
              elementType={titleElement || 'h2'}
              children={title || allPropertyData?.publication_title}
            />
            <ElementHTML
              elementType={'p'}
              style={{ color: paragraphHexa || '#1f1f1f' }}
              children={allPropertyData?.description}
            />
          </Col>
          <Col
            className="mt-5 pt-lg-4"
            lg={11}
          >
            <Row>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Tipo</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>{getType(allPropertyData)}</p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Valor</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getPrices(allPropertyData)?.at(0)?.price}
                  </p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Antigüedad</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>{getAge(allPropertyData)}</p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>m² totales</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getSurfaces(allPropertyData)?.total_surface}
                  </p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>m² cubiertos</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getSurfaces(allPropertyData)?.roofed}
                  </p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Orientación</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getOrientation(allPropertyData)}
                  </p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Ambientes</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getEnvironment(allPropertyData)}
                  </p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Dormitorios</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>{getRooms(allPropertyData)}</p>
                </div>
              </Col>
              <Col
                lg={4}
                xs={6}
              >
                <div className="item mb-5">
                  <h5 style={{ color: titleHexa || '#1f1f1f' }}>Baños</h5>
                  <p style={{ color: paragraphHexa || '#1f1f1f' }}>
                    {getBathrooms(allPropertyData)}
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutProperty_3
